export const getOrgIdFromPath = (pathname) => {
  if (!pathname) return null;
  const match = pathname.match(/^\/organisations\/(\d+)\/dashboard$/);
  return match ? Number(match[1]) : null;
};

export const isOrgDashboardRoute = pathname => getOrgIdFromPath(pathname) != null;

export const getOrgDashboardPath = orgId => `/organisations/${orgId}/dashboard`;
